import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FlashOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.34751 5.16753L8.85001 3.00003H14.85L13.35 9.75003H17.25L15.3825 12.1875L16.455 13.26L19.3575 9.45753C19.5179 9.24057 19.5494 8.95417 19.44 8.70753C19.3226 8.4304 19.051 8.25027 18.75 8.25003H15.1875L16.5 2.41503C16.5503 2.19077 16.495 1.95582 16.35 1.77753C16.2038 1.59712 15.9822 1.49464 15.75 1.50003H8.25001C7.89476 1.49053 7.58162 1.73165 7.50001 2.07753L7.09501 3.91503L8.34751 5.16753ZM22.5 21.4426L15.5175 14.4601L14.4525 13.3876L7.95 6.89262L6.6975 5.64012L2.5575 1.50012L1.5 2.55762L6.3 7.36512L5.25 11.8276C5.19636 12.0542 5.251 12.2928 5.39789 12.4735C5.54477 12.6542 5.76724 12.7564 6 12.7501H9.6225L8.25 21.6376C8.19904 21.9765 8.38427 22.3068 8.7 22.4401C8.79533 22.4788 8.89712 22.4992 9 22.5001C9.23212 22.4996 9.45091 22.3916 9.5925 22.2076L14.6025 15.6601L21.4425 22.5001L22.5 21.4426ZM6.94506 11.25L7.55256 8.61003L10.1926 11.25H6.94506ZM10.185 18.96L11.25 12.2775L13.5 14.5875L10.185 18.96Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FlashOff.vue"]]);
